import { render, staticRenderFns } from "./ProjHeader.vue?vue&type=template&id=1a1bda9a&"
import script from "./ProjHeader.vue?vue&type=script&lang=js&"
export * from "./ProjHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports